import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adding-custom-domain-names"
    }}>{`Adding Custom Domain Names`}</h1>
    <p>{`Custom domain names can be added to an environment in your AEM Cloud Service program through the Cloud Manager API. The steps required are:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#retrieve-custom-domains"
        }}>{`Retrieve the custom domains available.`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#obtain-dns-txt-record-value"
        }}>{`Obtain the DNS TXT record value of the domain you wish to add.`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#add-custom-domain-name"
        }}>{`Add the custom domain using the retrieved information`}</a></li>
    </ol>
    <p>{`This documents details the steps for adding custom domain names. Update, delete, and other APIs are available, but not covered in detail in this section.om domain name.`}</p>
    <h2 {...{
      "id": "retrieve-custom-domains"
    }}>{`Retrieve Custom Domains`}</h2>
    <p>{`Each program resource has a HAL link named `}<inlineCode parentName="p">{`http://ns.adobe.com/adobecloud/rel/domainNames`}</inlineCode>{`. To generate a list of existing custom domain names in your program, execute a GET request to the HAL link.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`GET https://cloudmanager.adobe.io/api/program/1234/domainNames
`}</code></pre>
    <p>{`This will return a list similar to the following.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_links": {
        "http://ns.adobe.com/adobecloud/rel/domain-name/certificates": {
            "href": "/api/program/1234/certificates",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/domain-name/deploy": {
            "href": "/api/program/1234/domain-name/403/deploy",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/domain-name/verify": {
            "href": "/api/program/1234/domain-name/403/verify",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/environment": {
            "href": "/api/program/1234/environment/1",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/program": {
            "href": "/api/program/1234",
            "templated": false
        },
        "self": {
            "href": "/api/program/1234/domain-name/403",
            "templated": false
        }
    },
    "id": 403,
    "name": "andu.yahoo.com",
    "dnsTxtRecord": "adobe-aem-verification=andu.yahoo.com/53/2/504af30f-3d87-4bcf-a5a1-95ecc5fb035d",
    "dnsZone": "yahoo.com.",
    "environmentId": 1,
    "certificateId": 1,
    "createdAt": "2020-07-03T10:59:35.175+0000",
    "updatedAt": "2020-07-03T10:59:35.175+0000",
    "status": "not_verified",
    "environmentName": "testenv-stage",
    "certificateName": "default-certificate-name"
}
`}</code></pre>
    <h2 {...{
      "id": "obtain-dns-txt-record-value"
    }}>{`Obtain DNS TXT Record Value`}</h2>
    <p>{`To add a custom domain, you must get a DNS TXT record value and zone for the domain name. In order to do this, execute a POST request by appending `}<inlineCode parentName="p">{`/validate`}</inlineCode>{` to the `}<inlineCode parentName="p">{`http://ns.adobe.com/adobecloud/rel/domainNames`}</inlineCode>{` HAL link of the program.`}</p>
    <p>{`The body of the POST request must include the following in order to validate if the domain entry can be created.`}</p>
    <ul>
      <li parentName="ul">{`Custom domain name `}</li>
      <li parentName="ul">{`Environment ID`}</li>
      <li parentName="ul">{`SSL certificate ID`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`POST https://cloudmanager.adobe.io/api/program/1234/domainNames/validate
{
    "name": "andu.yahoo.com",
    "environmentId": 2,
    "certificateId": 1
}
`}</code></pre>
    <p>{`This will return a response body that contains the domain zone and a TXT record that is used as an identifier.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "_links": {
        "http://ns.adobe.com/adobecloud/rel/domain-name/certificates": {
            "href": "/api/program/53/certificates",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/domain-name/deploy": {
            "href": "/api/program/53/domain-name//deploy",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/domain-name/verify": {
            "href": "/api/program/53/domain-name//verify",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/environment": {
            "href": "/api/program/53/environment/",
            "templated": false
        },
        "http://ns.adobe.com/adobecloud/rel/program": {
            "href": "/api/program/53",
            "templated": false
        },
        "self": {
            "href": "/api/program/53/domain-name/",
            "templated": false
        }
    },
    "dnsTxtRecord": "adobe-aem-verification=andu.yahoo.com/53/2/504af30f-3d87-4bcf-a5a1-95ecc5fb035d",
    "dnsZone": "yahoo.com."
}
`}</code></pre>
    <h2 {...{
      "id": "add-custom-domain-name"
    }}>{`Add Custom Domain Name`}</h2>
    <p>{`Having retrieved the necessary information you can now add your custom domain name. To do this, execute a POST request to `}<inlineCode parentName="p">{`http://ns.adobe.com/adobecloud/rel/domainNames`}</inlineCode>{` HAL link of the program. `}</p>
    <p>{`The body of the POST request needs to include the following data.`}</p>
    <ul>
      <li parentName="ul">{`Custom domain name`}</li>
      <li parentName="ul">{`Environment ID`}</li>
      <li parentName="ul">{`Certificate ID`}</li>
      <li parentName="ul">{`DNS TXT record value`}</li>
      <li parentName="ul">{`DNS zone`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`POST https://cloudmanager.adobe.io/api/program/1234/domainNames/
{
  "name": "customer.domain.com",
  "environmentId": 0,
  "certificateId": 0,
  "dnsTxtRecord": "adobe-aem-verification=www.adobe.com/1/2/ab-cd-ef",
  "dnsZone": "adobe.com."
}
`}</code></pre>
    <p>{`This will return a response similar to the following.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
"id": 0,
"name": "customer.domain.com",
"status": "ready",
"type": "CNAME",
"dnsResolution": [
{}
],
"dnsTxtRecord": "adobe-aem-verification=www.adobe.com/1/2/ab-cd-ef",
"dnsZone": "adobe.com.",
"environmentId": 0,
"environmentName": "customerEnvironmentName",
"tier": "publish",
"certificateId": 0,
"certificateName": "My certificate",
"certificateExpireAt": "2019-08-24T14:15:22Z",
"createdAt": "2019-08-24T14:15:22Z",
"updatedAt": "2019-08-24T14:15:22Z",
"_links": {
"http://ns.adobe.com/adobecloud/rel/domainName/certificates": {},
"http://ns.adobe.com/adobecloud/rel/domainName/deploy": {},
"http://ns.adobe.com/adobecloud/rel/domainName/verify": {},
"http://ns.adobe.com/adobecloud/rel/environment": {},
"http://ns.adobe.com/adobecloud/rel/program": {},
"self": {}
}
}
`}</code></pre>
    <h2 {...{
      "id": "limitations"
    }}>{`Limitations`}</h2>
    <p>{`Usage of this API has the following limitations.`}</p>
    <ul>
      <li parentName="ul">{`This API is applicable to AEM as a Cloud Service. `}</li>
      <li parentName="ul">{`Custom domain names can only be applied to production programs with Sites enabled.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      